import * as XLSX from "xlsx";

const SHEET_NAME = "Products";
const FILENAME = "inward_products_upload.xlsx";

const HEADERS = [
  "productSKU",
  "productName",
  // "productDescription",
  "invoiceQuantity",
  "receivedQuantity",
  "batchNumber",
  "manufacturingDate",
  // OLD: expiry provided in upload; expiry is now derived from Product Master shelfLifeDays
  // "expiryDate",
  "batchQuantity",
  // "condition",
  // "binCode", // Bin selection disabled for inward products template
];

export function downloadInwardProductsTemplate(products = []) {
  const rows = [
    HEADERS,
    ...products.map((p) => [
      p.sku || "",
      p.skuName || "",
      // p.description || "",
      // binCode (disabled)
      "",
      "",
      "",
      "",
      "",
      "",
      // "GOOD",
      "",
    ]),
  ];
  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws["!cols"] = [
    { wch: 18 },
    { wch: 18 },
    // { wch: 28 },
    { wch: 14 },
    { wch: 14 },
    { wch: 16 },
    { wch: 14 },
    { wch: 14 },
    { wch: 14 },
    { wch: 10 },
    { wch: 14 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
